import { lazy } from "react";

export const authRoutes = [
  {
    path: "/",
    element: lazy(() => import("../Screens/Auth/Login")),
    permission: 'public'
  },
  {
    path: "/register",
    element: lazy(() => import("../Screens/Auth/Register")),
    permission: 'public'
  },
  {
    path: "/verify-otp",
    element: lazy(() => import("../Screens/Auth/Verify")),
    permission: 'public'
  },
  {
    path: "/forget-password",
    element: lazy(() => import("../Screens/Auth/ForgotPassword")),
    permission: 'public'
  },

  // {
  //   path: "/error/403",
  //   element: lazy(() => import("../Screens/Error403")),
  //   permission: ['public']
  // },
  // {
  //   path: "*",
  //   element: lazy(() => import("../Screens/EmptyPage")),
  //   permission: ['superadministrator', 'read_only']
  // },
];

export const privateRoutes = [
  {
    path: "/home",
    element: lazy(() => import("../Screens/Home")),
    permission: ['superadministrator', 'read_only'],
    breadcrumb: "Home",
    permission: ['public']
  },
  {
    path: "/pharmacy",
    element: lazy(() => import("../Screens/Pharmacy")),
    permission: ["pharmacies.view-any", "pharmacies.view", "pharmacies.create", "pharmacies.update", "pharmacies.delete"],
    breadcrumb: "Home",
    permission: 'public'
  },
  {
    path: "/explore-all-medicines",
    element: lazy(() => import("../Screens/ExploreAllMedicines")),
    permission: ['superadministrator', 'read_only'],
    breadcrumb: "Home",
    permission: 'public'
  },
  {
    path: "/home-page",
    element: lazy(() => import("../Screens/HomePage")),
    permission: ["existing-items.view-any", "receipts.view-any", "receipts.view", "bills.create", "receipts.create", "item-cards.replacement", "all-pharma-items.replacement", "all-pharma-items.view-any", "all-pharma-items.view", "item-cards.view-any", "item-cards.view"],
    breadcrumb: "Home"
  },
  {
    path: "/warehouses",
    element: lazy(() => import("../Screens/Warehouses")),
    permission: ["distributors.view-any", "distributors.view"],
    breadcrumb: "Home"
  },
  {
    path: "/receipts",
    element: lazy(() => import("../Screens/Receipts")),
    permission: ["receipts.view-any", "receipts.view"],
    breadcrumb: "Home"
  },
  {
    path: "/bills/add-bill",
    element: lazy(() => import("../Screens/AddBill")),
    permission: ["bills.create", "bills.update"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/union-bills",
    element: lazy(() => import("../Screens/UnionBills")),
    permission: ["unions-bills.view", "unions-bills.view-any", "unions-bills.create"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/union-bills/add-union-bills",
    element: lazy(() => import("../Screens/AddUnionBills")),
    permission: ["unions-bills.create"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/required-materials",
    element: lazy(() => import("../Screens/RequiredMaterials")),
    permission: ["ordered-items.view-any", "ordered-items.view", "ordered-items.create", "ordered-items.update", "ordered-items.delete"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/bills",
    element: lazy(() => import("../Screens/Bills")),
    permission: ["bills.view-any", "bills.view"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/warehouse-orders",
    element: lazy(() => import("../Screens/WarehouseOrders")),
    permission: ["pharma-orders.view-any", "pharma-orders.view"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/products-you-want-to-sell-online",
    element: lazy(() => import("../Screens/ProductsYouWantToSellOnline")),
    permission: ["displayable-medicines.view-any", "displayable-medicines.view", "displayable-medicines.create", "displayable-medicines.create-by-array", "displayable-medicines.update", "displayable-medicines.delete"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/orders-dist",
    element: lazy(() => import("../Screens/OrdersDist")),
    permission: ["pharma-orders.view-any", "pharma-orders.view"],
    permission: "public",
    breadcrumb: "AddMedicine"
  },
  {
    path: "/orders-dist-doctor",
    element: lazy(() => import("../Screens/OrdersDistDoctor")),
    permission: "public",
    breadcrumb: "OrdersDistDoctor"
  },
  {
    path: "/open-accounting-transaction",
    element: lazy(() => import("../Screens/OpeningAccountingTransaction")),
    permission: ["accounting-transactions.opening"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/accounting-transaction",
    element: lazy(() => import("../Screens/AccountingTransaction")),
    permission: ["accounting-transactions.view-any", "accounting-transactions.view", "accounting-transactions.create", "accounting-transactions-composition.create"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/accounts/suppliers",
    element: lazy(() => import("../Screens/Suppliers")),
    permission: ["suppliers.view-any", "suppliers.view", "suppliers.create", "suppliers.update", "suppliers.delete"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/accounts/total-account-statement",
    element: lazy(() => import("../Screens/TotalAccountStatement")),
    permission: ["reports.aggregated-account"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/accounts/detailed-account-statement",
    element: lazy(() => import("../Screens/DetailedAccountStatement")),
    permission: ["reports.detailed-account", "reports.total-detailed-account"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/accounts/customer",
    element: lazy(() => import("../Screens/Customer")),
    permission: ["customers.view-any", "customers.view", "customers.create", "customers.update", "customers.delete"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/accounts/acounts-directory",
    element: lazy(() => import("../Screens/AcountsDirectory")),
    permission: ["public"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/material-inventory",
    element: lazy(() => import("../Screens/MaterialInventory")),
    permission: ["reports.existing-items"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/items-transactions",
    element: lazy(() => import("../Screens/ItemsTransactions")),
    permission: ["reports.items-transactions", "reports.total-items-transactions"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/closing-expire-date-item",
    element: lazy(() => import("../Screens/ClosingExpireDateItem")),
    permission: ["reports.closing-expire-date-item"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/profit-report",
    element: lazy(() => import("../Screens/ProfitReport")),
    permission: ["accounting-reports.profit-report"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/openingm-erchandise",
    element: lazy(() => import("../Screens/OpeningMerchandise")),
    permission: ["opening-merchandise.edit", "opening-merchandise.view", "opening-merchandise.delete", "opening-merchandise.delete-item"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/add-medicine",
    element: lazy(() => import("../Screens/AddMedicine")),
    permission: ["public"],
    breadcrumb: "AddMedicine"
  },
  {
    path: "/medicine",
    element: lazy(() => import("../Screens/Medicine")),
    permission: ["public"],
    breadcrumb: "Medicine"
  },
  {
    path: "/trial-balance",
    element: lazy(() => import("../Screens/TrialBalance")),
    permission: ["accounting-reports.trial-balance"],
    breadcrumb: "Medicine"
  },
  {
    path: "/users",
    element: lazy(() => import("../Screens/Users")),
    permission: ['users.view-any', 'users.view', "users.create", "users.update", "users.delete"],
    breadcrumb: "Medicine"
  },
  {
    path: "/roles",
    element: lazy(() => import("../Screens/Roles")),
    permission: ["public"],
    breadcrumb: "Medicine"
  },
  {
    path: "/orders",
    element: lazy(() => import("../Screens/Orders")),
    permission: ["orders.view-any", "orders.view"],
    breadcrumb: "Medicine"
  },
  {
    path: "/final-accounts",
    element: lazy(() => import("../Screens/FinalAccounts")),
    permission: ["accounting-reports.closing-accounts", "accounting-year-rotation.rotate"],
    breadcrumb: "Medicine"
  },
  {
    path: "/add-bill",
    element: lazy(() => import("../Screens/AddBill")),
    permission: ["bills.create", "bills.update"],
    breadcrumb: "Medicine"
  },
  {
    path: "/special-materials",
    element: lazy(() => import("../Screens/SpecialMaterials")),
    permission: ["pharma-products.view-any", "pharma-products.view", "pharma-products.create", "pharma-products.update", "pharma-products.delete"],
    breadcrumb: "Medicine"
  },
  {
    path: "/material-selection",
    element: lazy(() => import("../Screens/MaterialSelection")),
    permission: ["item-cards.view-any", "item-cards.view", "all-pharma-items.create"],
    breadcrumb: "Medicine"
  },
  {
    path: "/add-special-materials",
    element: lazy(() => import("../Screens/SpecialMaterials/Partials/AddSpecialMaterials")),
    permission: ["pharma-products.create", "pharma-products.update"],
    breadcrumb: "Medicine"
  },
  {
    path: "/repository",
    element: lazy(() => import("../Screens/Repository")),
    permission: ["pharmacy-warehouses.view-any", "pharmacy-warehouses.view", "pharmacy-warehouses.create", "pharmacy-warehouses.update", "pharmacy-warehouses.delete"],
    breadcrumb: "Medicine"
  },
  {
    path: "/subscription",
    element: lazy(() => import("../Screens/SubscriptionPlans")),
    permission: ["public"],
    breadcrumb: "Medicine"
  },
  {
    path: "/currency",
    element: lazy(() => import("../Screens/Currency")),
    permission: ["public"],
    breadcrumb: "Medicine"
  },
  {
    path: "/salesmen",
    element: lazy(() => import("../Screens/Salesmen")),
    permission: ["public"],
    breadcrumb: "Medicine"
  },
  {
    path: "/distribution-areas",
    element: lazy(() => import("../Screens/DistributionAreas")),
    permission: ["public"],
    breadcrumb: "Medicine"
  },
  {
    path: "/salesmen-regions",
    element: lazy(() => import("../Screens/SalesmenRegions")),
    permission: ["public"],
    breadcrumb: "SalesmenRegions"
  },
  {
    path: "/salesman-orders",
    element: lazy(() => import("../Screens/SalesmanOrders")),
    permission: ["public"],
    breadcrumb: "SalesmanOrders"
  },
  {
    path: "/error/404",
    element: lazy(() => import("../Screens/EmptyPage")),
    permission: ["public"]
  },
  {
    path: "*",
    element: lazy(() => import("../Screens/EmptyPage")),
    permission: ["public"]
  },
];
